import React from "react";

import ArrowRigth from "../icons/ArrowRigth";
// Styles
import "./CarouselControls.scss";

const MAIN_CLASS = "a-carousel-controls";

interface CarouselControlsProps {
    disablePrevBtn?: boolean;
    disableNextBtn?: boolean;
    onClickNextBtn?: () => void;
    onClickPrevBtn?: () => void;
}

const CarouselControls = ({
    disableNextBtn,
    disablePrevBtn,
    onClickNextBtn,
    onClickPrevBtn,
}: CarouselControlsProps) => {
    return (
        <div className={MAIN_CLASS}>
            <button
                onClick={onClickPrevBtn}
                type="button"
                disabled={disablePrevBtn}
                className={`${MAIN_CLASS}__control left`}
            >
                <ArrowRigth />
            </button>
            <button
                onClick={onClickNextBtn}
                type="button"
                className={`${MAIN_CLASS}__control`}
                disabled={disableNextBtn}
            >
                <ArrowRigth />
            </button>
        </div>
    );
};

export default CarouselControls;
